<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.printMultiplesOption.form.metersNum')" prop="metersNum" >
        <a-input-number
          v-model="form.metersNum"
          :min="0"
          :precision="0"
          :step="1"
          :placeholder="$t('views.printMultiplesOption.form.metersNumPlaceholder')"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.printMultiplesOption.form.multipleNum')" prop="multipleNum" >
        <a-input-number
          v-model="form.multipleNum"
          :min="0"
          :precision="2"
          :step="0.01"
          :placeholder="$t('views.printMultiplesOption.form.multipleNumPlaceholder')"
          style="width: 100%"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.printMultiplesOption.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.printMultiplesOption.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPrintMultiplesOption, addPrintMultiplesOption, updatePrintMultiplesOption } from '@/api/user/printMultiplesOption'

export default {
  name: 'CreateForm',
  props: {
    defaultPrintMultiplesId: {
      type: [Number, String],
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        printMultiplesId: null,
        metersNum: null,
        multipleNum: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false
    }
  },
  computed: {
    rules () {
      return {}
    },
    isLockedPrintMultiplesId () {
      const v = this.defaultPrintMultiplesId
      return v !== null && v !== undefined && v !== ''
    },
    lockedPrintMultiplesIdDisplay () {
      if (this.form.printMultiplesId != null && this.form.printMultiplesId !== '') {
        return String(this.form.printMultiplesId)
      }
      if (this.isLockedPrintMultiplesId) {
        return String(this.defaultPrintMultiplesId)
      }
      return ''
    }
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2 ? this.$t('views.printMultiplesOption.title.edit') : this.$t('views.printMultiplesOption.title.add')
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        printMultiplesId: null,
        metersNum: null,
        multipleNum: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      if (this.isLockedPrintMultiplesId) {
        this.$set(this.form, 'printMultiplesId', this.defaultPrintMultiplesId)
      }
      this.open = true
      this.formTitle = this.$t('views.printMultiplesOption.title.add')
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPrintMultiplesOption({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('views.printMultiplesOption.title.edit')
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePrintMultiplesOption(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.printMultiplesOption.msg.updateOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.printMultiplesOption.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPrintMultiplesOption(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.printMultiplesOption.msg.addOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.printMultiplesOption.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
